import classnames from 'classnames'

import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './PortfolioLozenge.module.css'

export interface PortfolioLozengeProps {
  testID?: string
  title: string
  isActive?: boolean
  onClick?: (evt: React.FormEvent<HTMLButtonElement>) => void
  disabled?: boolean
  theme?: 'light' | 'dark'
}

export default function PortfolioLozenge({
  testID,
  title,
  isActive,
  onClick,
  disabled = false,
  theme = 'light',
}: PortfolioLozengeProps) {
  const handleClick = (evt: React.FormEvent<HTMLButtonElement>) => {
    onClick?.(evt)
  }

  return (
    <button
      data-testid={testID}
      className={classnames(
        styles.button,
        isActive && styles.buttonActive,
        styles[theme]
      )}
      onClick={evt => handleClick(evt)}
      disabled={disabled}
    >
      <Text size={TextSizes.bodySml}>{title}</Text>
    </button>
  )
}
